export const ms = {
  msg:
    {
      username: 'Kata Nama',
      password: 'Kata Laluan',
      customer_id: 'Customer ID',
      login: 'Masuk',
      changeLanguage: '',
      'lang-en': 'English',
      'lang-ms': 'Bahasa Melayu',
      submit_button_text: 'Hantar',
      enter: 'Masuk',
      en: 'English',
      ms: 'Bahasa Melayu',
      id: 'Bahasa Indonesia',
      zh: 'Chinese',
      to: 'Tonga',
      sm: 'Samoan',
      copyright: 'Dikuasakan oleh Global Psytech',
      new_password: 'Kata Laluan Baharu',
      confirm_new_password: 'Sahkan Kata Laluan Baharu',
      forgot_password_header: 'Lupa Kata Laluan',
      basic_info: 'Maklumat asas',
      password_set: 'Tetapkan kata laluan',
      sign_up: 'Daftar',
      product_info: 'Produk Digunakan',
      continue: 'Teruskan',
      back: 'Belakang',
      cancel_reset: 'Batal',
      forgot_password: 'Terlupa Kata Laluan?',
      sign_up_message: 'untuk buat akaun',
      dpa_heading: 'Perjanjian Perlindungan Data Peribadi',
      dpa_body1: 'GFI dengan ini bersetuju untuk melindungi maklumat sulit yang diberikan selaras dengan Akta Perlindungan Data. Selaras dengan peraturan perlindungan data, kami akan memastikan bahawa data/ maklumat yang diterima dalam penilaian ini hanya akan diserahkan kepada pelanggan iaitu pihak Bank Rakyat.',
      dpa_body2: 'Semua data/ maklumat akan disimpan dan dikeluarkan dengan menggunakan kaedah yang sesuai dan selamat, tidak kira sama ada pelanggan berada di dalam atau di luar Malaysia.',
      dpa_body3: 'Sebarang komunikasi lanjut mengenai penggunaan data/ maklumat adalah tertakluk pada terma dan syarat pelanggan dan subjeknya.',
      close: 'Tutup',
      reset_button: 'Hantar',
      password_changed: 'Sila log masuk dengan kata laluan yang baharu.',
      successfully_register: 'Pendaftaran anda telah berjaya. Sila log masuk dengan menggunakan kata nama dan kata laluan yang telah didaftarkan.',
      cloned_user: 'Skor GFI anda sebelum ini masih sah. Oleh itu, anda tidak perlu mengambil semula penilaian GFI.',
      loading_text: 'Sedang dimuatnaik...',
      year_label: 'Tahun',
      month_label: 'Bulan',
      create_registration: 'Cipta Kata Nama dan Kata Laluan anda'
    },
  error: {

    full_name_required: 'Sila masukkan nama penuh anda seperti yang tertera pada NRIC.',
    full_name_min: 'Nama hendaklah mempunyai sekurang-kurangnya 5 karakter.',
    full_name_max: 'Nama hendaklah tidak melebihi 80 karakter.',
    full_name_regex: 'Karakter yang boleh diterima adalah abjad, nombor, jarak dan karakter khas seperti berikut: @ ’ - dan /',

    id_num_required: 'Sila masukkan nombor MyKad/pasport anda.',
    id_num_max: 'Nombor NRIC/ pasport hendaklah tidak melebihi 12 karakter.',
    id_num_regex: 'Karakter yang boleh diterima adalah abjad dan nombor sahaja.',

    business_reg_required: 'Sila masukkan Nombor Pendaftaran Perniagaan (BR)/Nombor Lesen Perniagaan.',
    business_reg_max: 'Nombor pendaftaran perniagaan(BR)/ nombor lesen perniagaan hendaklah tidak melebihi 15 karakter.',
    business_reg_min: 'Nombor pendaftaran perniagaan (BR)/ nombor lesen perniagaan hendaklah sekurang-kurangnya mempunyai 5 karakter.',
    business_reg_regex: 'Karakter yang boleh diterima adalah abjad dan nombor sahaja.',

    company_name_required: 'Sila masukkan nama syarikat anda.',
    company_name_min: 'Nama syarikat hendaklah mempunyai sekurang-kurangnya 5 karakter.',
    company_name_max: 'Nama syarikat hendaklah tidak melebihi 80 karakter.',
    company_name_regex: 'Karakter yang boleh diterima adalah abjad,nombor, jarak dan karakter khas seperti berikut: . - & () dan ’',

    application_number_required: 'Sila masukkan nombor applikasi anda',
    application_number_min: 'Nombor applikasi anda perlu mempunyai 6 karakter.',
    application_number_max: 'Nombor applikasi anda perlu mempunyai 6 karakter.',
    application_number_regex: 'Karakter yang boleh diterima adalah abjad, nombor dan karakter khas seperti berikut: -',

    customer_id_required: 'SIla masukkan customer ID anda.',
    customer_id_min: 'Customer ID hendaklah mempunyai sekurang-kurangnya 3 karakter.',
    customer_id_max: 'Customer ID hendaklah tidak melebihi 25 karakter.',
    customer_id_regex: 'Karakter yang boleh diterima adalah abjad, nombor dan karakter khas seperti berikut: -',

    business_category_required: 'Sila pilih kategori perniagaan.',

    is_existing_customer_required: 'Sila pilih status terkini anda.',

    product_applied_required: 'Sila pilih produk yang anda mohon.',
    commencement_date_required: 'Sila masukkan tarikh mula perniagaan syarikat anda.',

    facility_required: 'Sila pilih kemudahan yang anda mohon.',
    facilities_required: 'Sila pilih kemudahan yang anda mohon.',

    amount_applied_required: 'Sila masukkan jumlah pembiayaan yang diminta.',
    amount_applied_maxvalue: 'Jumlah pembiayaan haruslah tidak melebihi $ {1}.',
    amount_applied_minvalue: 'Jumlah pembiayaan mestilah sekurang-kurangnya $ {0}.',

    tenure_required: 'Sila masukkan tempoh bayaran balik yang dimohon.',
    tenure_maxvalue: 'Tempoh maksimum bayaran balik haruslah tidak melebihi {0} bulan.',
    tenure_minvalue: 'Tempoh minimum bayaran balik mestilah sekurang-kurangnya {0} bulan.',

    officer_required: 'Sila masukkan nombor ID EMK yang berurusan anda.',
    officer_invalid: 'ID EMK tidak sah.',
    officer_regex: 'Karakter yang boleh diterima adalah abjad, nombor dan karakter khas seperti berikut: ! # - dan @',
    officer_min: 'Nombor ID hendaklah mempunyai sekurang-kurangnya 6 karakter.',
    officer_max: 'Nombor ID tidak boleh melebihi 15 karakter.',

    username_required: 'Sila masukkan kata nama.',
    username_min: 'Kata nama anda hendaklah mempunyai sekurang-kurangnya 6 karakter.',
    username_max: 'Kata nama anda tidak boleh melebihi 15 karakter.',
    username_regex: 'Karakter yang boleh diterima adalah abjad, nombor dan karakter khas seperti berikut: ! # - dan @',
    username_duplicate: 'Kata nama telah digunakan. Sila masukkan kata nama yang lain.',

    password_required: 'Sila masukkan kata laluan.',
    password_min: 'Kata laluan hendaklah mempunyai sekurang-kurangnya 6 karakter.',
    password_max: 'Kata laluan tidak boleh melebihi 15 karakter.',
    password_regex: 'Karakter yang boleh diterima adalah abjad, nombor dan karakter khas seperti berikut: ! # - dan @',

    confirm_password_required: 'Sila masukkan semula kata laluan anda.',
    confirm_password_confirmed: 'Kata laluan anda dan kata laluan pengesahan tidak sepadan.',
    confirm_password_min: 'Kata laluan hendaklah mempunyai sekurang-kurangnya 6 karakter.',
    confirm_password_max: 'Kata laluan tidak boleh melebihi 15 karakter.',

    registrationtoken_required: 'Sila masukkan kod pengesahan yang telah diberikan kepada anda.',
    registrationtoken_min: 'Kod pengesahan anda perlu mempunyai 6 karakter.',
    registrationtoken_max: 'Kod pengesahan anda perlu mempunyai 6 karakter.',
    registrationtoken_duplicate: 'Kod pengesahan tidak sah. Sila masukkan kod pengesahan yang betul.',
    registrationtoken_regex: 'Karakter yang boleh diterima adalah abjad dan nombor sahaja.',

    confirm_password_placeholder: 'Sila masukkan semula kata laluan anda.',

    error: 'Kata nama atau kata laluan tidak sah.',

    officerinchargeid_required: 'Sila masukkan nombor ID EMK yang berurusan dengan anda.',
    officerinchargeid_invalid: 'Nombor ID EMK tidak sah. Sila masukkan ID EMK yang betul.',
    officerinchargeid_regex: 'Karakter yang boleh diterima adalah abjad dan nombor sahaja.',
    officerinchargeid_min: 'Nombor ID hendaklah mempunyai sekurang-kurangnya 6 karakter.',
    officerinchargeid_max: 'Nombor ID tidak boleh melebihi 15 karakter.',

    new_password_placeholder: 'Sila masukkan kata laluan baharu anda.',
    new_password_min: 'Kata laluan hendaklah mempunyai sekurang-kurangnya 6 karakter.',
    new_password_max: 'Kata laluan tidak boleh melebihi 15 karakter.',
    confirm_new_password_placeholder: 'Sila masukkan semula kata laluan baharu anda untuk pengesahan.',
    invalid_credentials: 'Kata nama atau kata laluan tidak sah.',
    user_blocked: 'Akaun anda telah disekat selepas beberapa percubaan log masuk berturut-turut, sila hubungi support.',

    registration_error: 'Something went wrong please try again',
    new_password_required: 'Sila masukkan kata laluan baharu anda.',
    confirm_new_password_required: 'Sila masukkan semula kata laluan anda untuk pengesahan.',
    register_username_details_does_not_match: 'Nombor pengenalan anda tidak sepadan dengan rekod pendaftaran.',
    register_username_not_found: 'Terlupa kata nama anda? Sila maklumkan pegawai bank yang berurusan dengan anda.',
    consent_required: 'Anda perlu membaca Perjanjian Perlindungan Data Peribadi dan menyatakan persetujuan anda dalam kotak yang disediakan sebelum anda boleh didaftarkan.',
    branch_required: 'Sila pilih cawangan.',

    reset_invalid: 'We are unable to find your account by the details provided. MS',
    confirm_new_password_confirmed: 'Kata laluan anda dan kata laluan pengesahan tidak sepadan.',
    drop_down_not_available: 'Tiada data tersedia.',
    repeating_user: 'Maaf, pendaftaran anda tidak dapat diproses.',

    years_required: 'Sila pilih tahun.',
    months_required: 'Sila pilih bulan.'
  },
  registration: {
    full_name: 'Nama penuh (seperti yang tertera pada NRIC)',
    id_num: 'Nombor Pengenalan (ID)',
    application_number: 'Nombor Applikasi',
    customer_id: 'Customer ID',
    is_existing_customer: 'Adakah anda pelanggan sedia ada?',
    business_reg: 'Nombor Pendaftaran Perniagaan (BR)/ Nombor Lesen Perniagaan)',
    company_name: 'Nama Syarikat',
    product_applied: 'Produk yang dimohon',
    commencement_date: 'Tarikh Mula Perniagaan',
    facilities: 'Kemudahan yang dimohon',
    amount_applied: 'Jumlah Pembiayaan yang Diminta ($)',
    tenure: 'Tempoh Pembiayaan (dalam bulan)',
    tenure_years: 'Tempoh Pembiayaan (dalam tahun)',
    tenure_months: 'Tempoh Pembiayaan (dalam bulan)',
    tenure_required: 'Sila masukkan tempoh pembiayaan.',
    business_category: 'Kategori Perniagaan',
    confirm_password: 'Sahkan Kata Laluan',
    verification_code: 'Kod Pengesahan',
    consent1: 'Saya mengesahkan bahawa saya telah membaca',
    consent2: ' Perjanjian Perlindungan Data Peribadi',
    consent3: 'serta bersetuju dengan pemprosesan data peribadi saya.',
    cancel: 'Batal',
    register: 'Daftar',
    branch: 'Cawangan',
    officer: 'No. ID EMK',
    years_required: 'Sila pilih tahun.',
    months_required: 'Sila pilih bulan.'
  }
}
